import React, { useState } from "react";
import "./header.css";
import { nav } from "../../data/Data";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const Header = () => {
  const [navList, setNavList] = useState(false);
  const { t, i18n } = useTranslation();

  return (
    <>
      <header>
        <div className="container flex">
          {/* Logo */}
          <div className="logo">
            <a href="/">
              <img src="./images/logo.png" alt="" />
            </a>
          </div>

          {/* Navigation */}
          <div className="nav">
            <ul className={navList ? "small" : "flex"}>
              {nav.map((list, index) => (
                <li key={index}>
                  <Link to={list.path}>{t(list.text)}</Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Phone + Language Dropdown (tight spacing) */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "6px", // 👈 reduce gap here
            }}
          >
            {/* Phone Number Button */}
            <div
              className="callbutton"
              style={{
                color: "#ffffff",
                fontWeight: "400",
                display: "flex",
                alignItems: "center",
                gap: "4px",
                background: "#007bff",
                padding: "8px 14px",
                borderRadius: "6px",
                cursor: "default",
              }}
            >
              <span className="fa fa-phone"></span>
              +974 30666937
            </div>

            {/* Language Dropdown */}
            <select
              className="langDropdown"
              onChange={(e) => i18n.changeLanguage(e.target.value)}
              style={{
                color: "#ffffff",
                fontWeight: "400",
                background: "#007bff",
                padding: "8px 14px",
                borderRadius: "6px",
                cursor: "pointer",
                border: "none",
              }}
            >
              <option value="en">English</option>
              <option value="ar">عربي</option>
              <option value="hi">हिन्दी</option>
              <option value="ur">اردو</option>
            </select>
          </div>

          {/* Mobile Toggle */}
          <div className="toggle">
            <button onClick={() => setNavList(!navList)}>
              {navList ? (
                <i className="fa fa-times"></i>
              ) : (
                <i className="fa fa-bars"></i>
              )}
            </button>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
